// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-icon-margin--8 .MuiListItemIcon-root{margin-left:-8px}`, "",{"version":3,"sources":["webpack://./src/components/menu/menu.scss"],"names":[],"mappings":"AACE,2CACE,gBAAA","sourcesContent":[".menu-icon-margin--8 .MuiListItemIcon-root{margin-left:-8px}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
